import { StackProps, VStack } from '@chakra-ui/react';
import * as React from 'react';

import { Group } from './components/Group';

export const Groups: React.FC<StackProps> = ({ ...stackProps }) => {
  return (
    <VStack spacing="4" {...stackProps}>
      {Array(5)
        .fill(0)
        .map((_, i) => (
          <Group key={i} width="full" />
        ))}
    </VStack>
  );
};
